import React, {useMemo} from 'react';

import moment from 'moment';
import styled from 'styled-components';

import {LazyTooltip} from 'app/components/general/LazyTooltip';

const StyledFixedTH = styled.th`
  white-space: nowrap;
  background-color: white;
  position: sticky;
  top: 0;
`;

const StyledFixedTable = styled.table.attrs<{className?: string}>({
  className: 'table table-hover',
})`
  position: relative;
  thead {
    position: relative;
    z-index: 2;
  }
`;

interface FixableHeaderProps {
  children: React.ReactChild;
  textAlign?: 'center' | 'right';
}

export function FixableHeader({
  children,
  textAlign,
}: FixableHeaderProps): JSX.Element {
  return (
    <StyledFixedTH
      scope="col"
      className={textAlign != null ? `text-${textAlign}` : undefined}
    >
      {children}
    </StyledFixedTH>
  );
}

interface FixableTableProps {
  children: React.ReactChild | React.ReactChild[];
}

export function FixableTable({children}: FixableTableProps): JSX.Element {
  return <StyledFixedTable>{children}</StyledFixedTable>;
}

interface DateTextProps {
  children: string | null;
}

export function DateText({children}: DateTextProps): JSX.Element {
  const [text, tooltip] = useMemo(() => {
    const date = moment(children);
    return [
      date.isValid() ? date.format('ll') : '',
      date.isValid() ? date.format('lll') : '',
    ];
  }, [children]);

  return (
    <LazyTooltip tooltip={tooltip}>
      <div>{text}</div>
    </LazyTooltip>
  );
}
